import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Home Components
import Home from './pages/home/Home';
import Navbar from './pages/home/Navbar';


// Quiz Components
import Quiz from './pages/quiz/Quiz';
import QuizStarting from './pages/pages/QuizStarting';
import QuizDetailsPage from './pages/pages/QuizDetailsPage';
import QuizNumber from './pages/pages/QuizNumber';
import NumberOfQuestions from './pages/pages/NumberOfQuestions';
import PageNotFound from './pages/home/PageNotFound';

import QuizReStarting from './pages/pages/QuizReStarting';

import Bottombar from './pages/home/Bottombar';
import About from './pages/home/About';
import Contact from './pages/home/Contact';
import PrivacyPolicy from './pages/home/PrivacyPolicy';
import Footer from './pages/home/Footer';
import PDFViewer from './pages/topics/PDFViwer';
import MoreOptions from './pages/home/MoreOptions';

import Page from './pages/pages/Page';
import OnlineReadBook from './pages/pages/OnlineReadBook';
import QuizMathTopics from './pages/quiz/subjects/QuizMathTopics';
import QuizReasoningTopics from './pages/quiz/subjects/QuizReasoningTopics';
import QuizEnglishTopics from './pages/quiz/subjects/QuizEnglishTopics';
import QuizGKTopics from './pages/quiz/subjects/QuizGKTopics';
import QuestionSolution from './pages/pages/QuestionSolution';



const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

const AppContent = () => {
  const location = useLocation();

  return (

    <>
      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&
        <Navbar />}


      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&
        !location.pathname.startsWith('/online-practics-questions') &&
        !location.pathname.startsWith('/practivs-important-questions') &&
        !location.pathname.startsWith('/practice-random-question/all') &&
        !location.pathname.startsWith('/practice-random-question/physics') &&
        !location.pathname.startsWith('/practice-random-question/chemistry') &&
        !location.pathname.startsWith('/practice-random-question/biology') &&
        !location.pathname.startsWith('/pdfviewer') &&
        !location.pathname.startsWith('/onlinereadbook') &&
        !location.pathname.startsWith('/account-deletion') &&

        <Bottombar />}

      <Routes>
        {/* Public Routes */}
        <Route path='/' element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/*
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/report-send/:id" element={<ReportSend />} />
        <Route path="/report-question" element={<ReportQuestion />} />
        <Route path="/report-question-details/:id/:displayId/:message" element={<ReportQuestionDetails />} />
   */}


        <Route path="/page" element={<Page />} />

        <Route path="/more-options" element={<MoreOptions />} />

        <Route path="/pdfviewer/:pdfId/:pdfName/:fileId" element={<PDFViewer />} />
        <Route path="/onlinereadbook/:type/:subject/:topic" element={<OnlineReadBook />} />
        <Route path="/question-solution/:id" element={<QuestionSolution />} />

        {/* Quiz Routes (no navbar) */}
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/quiz/Mathematics" element={<QuizMathTopics />} />
        <Route path="/quiz/reasoning" element={<QuizReasoningTopics />} />
        <Route path="/quiz/english" element={<QuizEnglishTopics />} />
        <Route path="/quiz/general-knowledge" element={<QuizGKTopics />} />
        <Route path="/quiz-starting/:type/:subject/:topic/:quizNo/:quesNum/:subjectName" element={<QuizStarting />} />
        <Route path="/quiz-restarting/:quizsubjectName/:quizId/:id" element={<QuizReStarting />} />
        <Route path="/quiz-details/:quizId" element={<QuizDetailsPage />} />
        <Route path="/quiz-number/:type/:subject/:topic/:subjectName" element={<QuizNumber />} />
        <Route path="/number-of-questions/:type/:subject/:topic/:quizNo/:subjectName" element={<NumberOfQuestions />} />
        <Route path="*" element={<PageNotFound />} />


        {/*
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/update-profile" element={<UpdateProfile />} />
        <Route path="/account-delete" element={<AccountDelete />} />
        <Route path="/account-deletion" element={<AccountDeletionInstructions />} />
       



        <Route path='admin-home' element={<AdminHome />} />
        <Route path="/all-users-data" element={<AllUsers />} />
        <Route path="/all-users-before-login" element={<AllUsersBeforeLogin />} />
        <Route path="/app-install-users" element={<AppInstallUsers />} />
        <Route path="/app-items-use" element={<AppItemsUse />} />
        <Route path="/items-price" element={<ItemsPrice />} />


        <Route path="/payment-details" element={<PaymentDetails />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/share-payment/:price/:couponName/:phone" element={<SharePay />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />


        <Route path="/online-practics-questions/:subject/:topic/:type" element={<OnlinePracticsQuestions />} />
        <Route path="/question-solution/:id" element={<QuestionSolution />} />
        <Route path="/bookmarked-questions" element={<BookmarkedQuestions />} />
        <Route path="/bookmarked-pdfs" element={<PdfsBookmark />} />
        <Route path="/questions-history" element={<QuestionHistory />} />
        <Route path="/subject-progress" element={<SubjectProgress />} />
        <Route path="/practice-random-question" element={<PracticeRamdomQuestion />} />
        <Route path="/practice-random-question/:subject" element={<PracticsRandomQuestions />} />
        <Route path="/practice-question-topics" element={<PracticsQuestionTopics />} />
        <Route path="/pdfviewer/:pdfId/:pdfName/:fileId" element={<PDFViewer />} />
        <Route path="/onlinereadbook/:type/:subject/:topic" element={<OnlineReadBook />} />




        <Route path="/syllabus" element={<Syllabus />} />
        <Route path="/syllabus/physics" element={<SyllabusPhys />} />
        <Route path="/syllabus/chemistry" element={<SyllabusChem />} />
        <Route path="/syllabus/biology" element={<SyllabusBio />} />

        <Route path="/ncertbook" element={<NcertBooks />} />
        <Route path="/ncertbook/physics" element={<NcertBookPhysTopics />} />
        <Route path="/ncertbook/chemistry" element={<NcertBookChemTopics />} />
        <Route path="/ncertbook/biology" element={<NcertBookBioTopics />} />

        */}





      </Routes>

      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&
        !location.pathname.startsWith('/online-practics-questions') &&
        !location.pathname.startsWith('/practivs-important-questions') &&
        !location.pathname.startsWith('/practice-random-question/all') &&
        !location.pathname.startsWith('/practice-random-question/physics') &&
        !location.pathname.startsWith('/practice-random-question/chemistry') &&
        !location.pathname.startsWith('/practice-random-question/biology') &&
        !location.pathname.startsWith('/onlinereadbook') &&

        <Footer />}

    </>

  );
};

export default App;